// extracted by mini-css-extract-plugin
export var pageContainer = "_g-1";
export var settingsContent = "_g-0";